import type { AxiosInstance } from 'axios';
import { type ReactNode, createContext, useContext } from 'react';

const AuthenticatedImageApiContext = createContext<AxiosInstance | null>(null);

export interface IAuthenticatedImageApiProviderProps {
  api: AxiosInstance | null;
  children: ReactNode;
}

export const AuthenticatedImageApiProvider = ({
  api,
  children,
}: IAuthenticatedImageApiProviderProps): JSX.Element => (
  <AuthenticatedImageApiContext.Provider value={api}>
    {children}
  </AuthenticatedImageApiContext.Provider>
);

export const useAuthenticatedImageApi = (): AxiosInstance | null =>
  useContext(AuthenticatedImageApiContext);
